class Job {
  static readonly REGISTERED: string = 'r';
  static readonly GENERATING_IMAGE = 'i';
  static readonly GENERATING_WORD = 'w';
  static readonly FINISHED: string = 'f';

  id: number;
  folder_name: string;
  total_images: number;
  finished_images: number;
  status: string;
  started_at: string;
  ended_at: string;

  constructor() {
    this.id = 0;
    this.folder_name = '';
    this.total_images = 0;
    this.finished_images = 0;
    this.status = '';
    this.started_at = '';
    this.ended_at = '';
  }

  load(data: any) {
    this.id = data.id;
    this.folder_name = data.folder_name;
    this.total_images = data.total_images;
    this.finished_images = data.finished_images;
    this.status = data.status;
    this.started_at = data.started_at;
    this.ended_at = data.ended_at;
  }

  buildFormData(): FormData {
    const data = new FormData();

    data.append('id', this.id.toString());
    data.append('folder_name', this.folder_name);
    data.append('total_images', this.total_images.toString());
    data.append('finished_images', this.finished_images.toString());
    data.append('status', this.status);
    data.append('started_at', this.started_at);
    data.append('ended_at', this.ended_at);

    return data;
  }
}

export default Job;
